import React from 'react';
import PropTypes from 'prop-types';
import SortIcon from '-!svg-react-loader!./assets/sort.svg?name=SortIcon';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Row, Col } from 'reactstrap';
import { Drawer, Button } from 'antd';
import reducer from './reducer';
import saga from './saga';
import { removeAllOptions, showAllTags, orderBy } from './actions';
import {
  makeSelectFiltersOption,
  makeSelectSort,
  makeSelectSelectedSort,
} from './selectors';
import {
  SECTION_DESCRIPTION,
  SECTION_TITLE,
  SECTION_SINGLE_TITLE,
} from './constants';

import { resetParams, getFilters } from '../Search/actions';
import { makeSelectLabels, makeSelectParam } from '../Search/selectors';
import { default as Search } from 'components/Search/';
import { makeSelectCheckResponse } from '../PrescoringTool/selectors'
import { messages } from '../SearchFilters/messages';

import Tags from './tags';

import 'antComponentsStyle';
import './styles.scss';

class HorizontalFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterDrawerIsOpen: true,
    };
  }

  componentDidMount() {
    // trick per montare il drawer dei filtri fin da subito,
    // evitando un load filters e fetch offers alla prima apertura che causava il reset del prescoring
    this.setState({filterDrawerIsOpen: false});
  }

  get hasConfirmMessage() {
    let { prescoringResponse } = this.props;
    prescoringResponse = prescoringResponse.hasOwnProperty('_root') ? prescoringResponse.toJS() : prescoringResponse;

    return prescoringResponse && prescoringResponse.hasOwnProperty('chance') && prescoringResponse.chance !== null;
  }

  onCancelClick = () => {
    if (!this.hasConfirmMessage || (this.hasConfirmMessage && confirm(messages.confirmMessageReset))) {
      this.props.clearParams();
      this.props.clearFilters();
      this.props.showTags();
      this.props.getFilters();
    }
  };

  onOrderChange = e => {
    this.props.orderBy(e.target.value);
  };

  openFilterDrawer = () => this.setState({ filterDrawerIsOpen: true });
  closeFilterDrawer = () => this.setState({ filterDrawerIsOpen: false });

  render() {
    const {
      results,
      sort,
      selectedSort,
      selectedTags,
      activeFilters,
      params,
      label,
      id
    } = this.props;
    const selected = [...selectedTags, ...activeFilters];

    return (
      <div id="HorizontalFilter">
        <div className="element-wrapper">
          <div className="element-actions">
            <div className="form-inline justify-content-sm-end">
              <span className="sort-label">
                <SortIcon /> {SECTION_DESCRIPTION}
              </span>
              <label htmlFor={id} className="mb-0 sr-only sr-only-focusable">
                {label}
              </label>
              <select
                value={selectedSort}
                className="form-control form-control-sm form-control-faded"
                onChange={this.onOrderChange}
                id={id}
              >
                {sort.map((item, key) => (
                  <option value={item.value} key={key}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <h1 className="element-header text-medium">
            {results} {results === 1 ? SECTION_SINGLE_TITLE : SECTION_TITLE}
            <Button onClick={this.openFilterDrawer} icon="control" className="d-none d-md-inline d-xl-none ml-4 open-filters-mobile-button"
              type={selected.length > 0 ? 'primary' : 'default'} ghost={selected.length > 0}
            >
              Filtra
            </Button>
          </h1>

          <Drawer
            title="Filtra le offerte"
            placement="left"
            closable={true}
            onClose={this.closeFilterDrawer}
            visible={this.state.filterDrawerIsOpen}
            width={400}
            className="d-none d-md-block d-xl-none"
          >
            <Search />
          </Drawer>

          {selected.length > 0 && (
            <Row>
              <Col md={12} sm={12}>
                <Tags tags={selected} active params={params} hasConfirmMessage={this.hasConfirmMessage} />
                <div className="clear" onClick={this.onCancelClick}>
                  Rimuovi i filtri
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

HorizontalFilter.defaultProps = {};
HorizontalFilter.propTypes = {
  results: PropTypes.number.isRequired,
};

const mapStateToProps = createStructuredSelector({
  selectedTags: makeSelectFiltersOption(),
  activeFilters: makeSelectLabels(),
  sort: makeSelectSort(),
  selectedSort: makeSelectSelectedSort(),
  prescoringResponse: makeSelectCheckResponse(),
  params: makeSelectParam(),
});

export function mapDispatchToProps(dispatch) {
  return {
    clearFilters: () => dispatch(removeAllOptions()),
    clearParams: () => dispatch(resetParams()),
    getFilters: () => dispatch(getFilters()),
    showTags: () => dispatch(showAllTags()),
    orderBy: value => dispatch(orderBy(value)),
  };
}

const withReducer = injectReducer({ key: 'filters', reducer });
const withSaga = injectSaga({ key: 'filters', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(HorizontalFilter);
